import { Component, input, InputSignal, OnDestroy, signal, WritableSignal, inject } from '@angular/core'
import { WatchListAssetInterface } from '@modules/watch-list-module/interfaces/watch-list-asset.interface'
import { Subject, takeUntil } from 'rxjs'
import { TuiDialog } from '@taiga-ui/core'
import { HttpErrorResponse } from '@angular/common/http'
import { WatchListService } from '@modules/watch-list-module/services/watch-list.service'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { ConfirmDialogComponent } from '@shared/components/common/confirm-dialog/confirm-dialog.component'
import { AlertService } from '@shared/services/alert.service'
import { ButtonComponent } from '@shared/components/ui-kit/button/button.component'

@Component({
	selector: 'app-watch-list-actions',
	templateUrl: './watch-list-actions.component.html',
	styleUrl: './watch-list-actions.component.scss',
	imports: [TranslatePipe, ConfirmDialogComponent, TuiDialog, ButtonComponent],
})
export class WatchListActionsComponent implements OnDestroy {
	public asset: InputSignal<WatchListAssetInterface | null> = input<WatchListAssetInterface | null>(null)

	private _destroy$: Subject<void> = new Subject<void>()

	private readonly _alertService: AlertService = inject<AlertService>(AlertService)
	private readonly _translateService: TranslateService = inject<TranslateService>(TranslateService)
	private readonly _watchListService: WatchListService = inject<WatchListService>(WatchListService)

	protected isOpenConfirmDeleteAsset: WritableSignal<boolean> = signal(false)
	protected isLoadingConfirm: WritableSignal<boolean> = signal(false)
	protected onToggleDialog(value: boolean): void {
		this.isOpenConfirmDeleteAsset.set(value)
	}

	protected onDeleteAsset(): void {
		const symbol: string | undefined = this.asset()?.symbol
		if (!symbol) return

		this.isLoadingConfirm.set(true)

		this._watchListService
			.deleteAsset(symbol)
			.pipe(takeUntil(this._destroy$))
			.subscribe(
				(): void => {
					this._alertService.success(
						this._translateService.instant('watchList.actions.deleteSuccess', { symbol }),
					)
					this.isLoadingConfirm.set(false)
					this.onToggleDialog(false)
				},
				(error: HttpErrorResponse): void => {
					this._alertService.error(
						error?.error?.error.message ||
							this._translateService.instant('watchList.actions.deleteFail', { symbol }),
					)
					this.isLoadingConfirm.set(false)
					this.onToggleDialog(false)
				},
			)
	}

	ngOnDestroy(): void {
		this._destroy$.next()
		this._destroy$.complete()
	}
}
